/**
 * Classe responsavel pela manipulação dos eventos
 */
export class EventService {

  getEventsWaitingConfirmation() {

    let events = [
      { entity: "UTI, HAOC", date: "quinta - 24/08/2017", time: "09:00 - 18:00", status: "waiting_confirmation" },
      { entity: "UTI, HAOC", date: "sexta - 25/08/2017", time: "09:00 - 18:00", status: "waiting_confirmation" },
    ]

    return this.setEventsStatus(events)
  }

  getEventExchanges() {

    let events = [
      { entity: "UTI, HAOC", date: "sábado - 26/08/2017", time: "09:00 - 18:00", status: "exchange" }
    ]

    return this.setEventsStatus(events)
  }

  getConfirmedEvents() {

    let events = [
      { entity: "UTI, HAOC", date: "segunda - 21/08/2017", time: "09:00 - 18:00", status: "confirmed" },
      { entity: "UTI, HAOC", date: "terça - 22/08/2017", time: "09:00 - 18:00", status: "confirmed" },
      { entity: "UTI, HAOC", date: "quarta - 23/08/2017", time: "09:00 - 18:00", status: "confirmed" },
    ]

    return this.setEventsStatus(events)
  }

  getNextEvents() {

    let events = [
      { entity: "UTI, HAOC", date: "segunda - 21/08/2017", time: "09:00 - 18:00", status: "confirmed" },
      { entity: "UTI, HAOC", date: "terça - 22/08/2017", time: "09:00 - 18:00", status: "confirmed" },
      { entity: "UTI, HAOC", date: "quarta - 23/08/2017", time: "09:00 - 18:00", status: "confirmed" },
      { entity: "UTI, HAOC", date: "quinta - 24/08/2017", time: "09:00 - 18:00", status: "waiting_confirmation" },
      { entity: "UTI, HAOC", date: "sexta - 25/08/2017", time: "09:00 - 18:00", status: "waiting_confirmation" },
    ]

    return this.setEventsStatus(events)
  }

  setEventsStatus(events) {

    events.forEach((event) => {

      event.statusData = {}

      if (event.status == "confirmed") {

        event.statusData = { icon: "checkmark-circle", color: "success", description: "Confirmado" }

      } else if (event.status == "waiting_confirmation") {

        event.statusData = { icon: "time", color: "warning", description: "Aguardando confirmação" }

      } else if (event.status == "exchange") {

        event.statusData = { icon: "redo", color: "pink", description: "Troca solicitada por Fulano" }
      }
    })

    return events
  }
}



// WEBPACK FOOTER //
// ./src/services/event.ts